// Global instance of the observer that serves as an eventbus for the whole application

// dependencies
import observer from '@/libs/ni-observer';
const pubsub = {};

observer(pubsub);

export default pubsub;
